import { Nullable } from 'constants/types'

interface IAnalyticsValue {
    name: string
    value: string | number
}

export class Article {
    public _id: Nullable<string>
    public get id(): Nullable<string> {
        return this._id
    }

    private analyticsValues: Array<IAnalyticsValue> = []

    public constructor(public el: HTMLElement) {
        this._id = el.getAttribute('data-article-id')
    }

    /**
     * Update the outerHTML string of the element with an analytics value
     */
    public setAnalyticsValue(key: string, value: string): void {
        const analyticsValue: IAnalyticsValue = {
            name: key,
            value: value
        }

        this.analyticsValues.push(analyticsValue)
    }

    /**
     * Get the outerHTML of the element, with analytics values injected
     */
    public getOuterHTML(): string {
        let dataEvtVal: string = this.el.getAttribute('data-evt-val') || ''
        if (dataEvtVal) {
            //apply the analytics values to the article html before returning
            this.analyticsValues.forEach((analyticsValue: IAnalyticsValue) => {
                dataEvtVal = dataEvtVal.replace(
                    '${ ' + analyticsValue['name'] + ' }',
                    analyticsValue['value'].toString()
                )
            })
            // get rid of attributes with empty string value
            const dataEvtValJson = JSON.parse(dataEvtVal)
            for (const attributeName in dataEvtValJson) {
                if (!dataEvtValJson[attributeName]) {
                    delete dataEvtValJson[attributeName]
                }
            }
            this.el.setAttribute('data-evt-val', JSON.stringify(dataEvtValJson))
        }
        return this.el.outerHTML
    }
}
